// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-button-styles {
  background-color: #fff;
  color: #000;
  border: solid 1px #e0e0e0;
  border-radius: 4px;
  margin: 5px 5px 5px 0;
}

.download-button-styles-proceed {
  background-color: #0062fe;
  color: #ffffff;
}

.download-button-styles-proceed:hover {
  background-color: #000000;
  color: #ffffff;
}

.download-warning-container {
  background-color: rgba(162, 208, 255, 0.3450980392);
  margin: 20px 0;
  padding: 15px;
}
.download-warning-container svg.download-warning-icon {
  fill: #0000ff;
  margin: 0 15px 0 3px;
}

.download-page-recovery-codes-container {
  background-color: #fff;
  color: #000;
  border: solid 1px #0062fe;
  border-radius: 4px;
  margin: 20px 0;
}
.download-page-recovery-codes-container #download-page-recovery-codes {
  border-radius: 4px;
  border: solid 3px red;
  width: 20%;
  aspect-ratio: 1/1;
}`, "",{"version":3,"sources":["webpack://./src/pages/accountServices/Styles/DownloadRecoveryCodePage.scss","webpack://./src/scss/abstracts/_mixins.scss","webpack://./src/scss/abstracts/_variables.scss"],"names":[],"mappings":"AAEA;ECYI,sBADwC;EAExC,WAFsD;EAGtD,yBAHqE;EAIrE,kBAJwG;EDTxG,qBAAA;AAEJ;;AACE;EACE,yBEFS;EFGT,cAAA;AAEJ;;AACE;EACE,yBAAA;EACA,cAAA;AAEJ;;AACE;EACE,mDEdW;EFeX,cAAA;EACA,aAAA;AAEJ;AADI;EACE,aEjBc;EFkBd,oBAAA;AAGN;;AACE;ECbE,sBADwC;EAExC,WAFsD;EAGtD,yBDaU;ECZV,kBAJwG;EDkBxG,cAAA;AAGJ;AAFI;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;AAIN","sourcesContent":["@import '../../../scss/styles';\n\n.download-button-styles {\n    @include borderedBoxStyles;\n    margin: 5px 5px 5px 0;\n  }\n  \n  .download-button-styles-proceed {\n    background-color: $cds-primary;\n    color: #ffffff\n  }\n  \n  .download-button-styles-proceed:hover {\n    background-color: #000000;\n    color: #ffffff;\n  }\n  \n  .download-warning-container {\n    background-color: $info-bg-color;\n    margin: 20px 0;\n    padding: 15px;\n    svg.download-warning-icon {\n      fill: $blue-icon-bg-color;\n      margin: 0 15px 0 3px;\n    }\n  }\n  \n  .download-page-recovery-codes-container {\n    @include borderedBoxStyles(\n      $border:solid 1px $cds-primary);\n      \n    margin: 20px 0;\n    #download-page-recovery-codes {\n      border-radius: 4px;\n      border: solid 3px red;\n      width: 20%;\n      aspect-ratio: 1 / 1;\n    }\n  }\n  \n","@mixin flexCenterRow($justify-content: center, $align-items:center, $align-content: none) {\n    display: flex;\n    justify-content: $justify-content;\n    align-items: $align-items;\n    align-content: $align-content;\n}\n@mixin flexCenterColumn($justify-content: center, $align-items:center, $align-content: none) {\n    display: flex;\n    flex-direction: column;\n    justify-content: $justify-content;\n    align-items: $align-items;\n    align-content: $align-content;\n}\n@mixin borderedBoxStyles($background-color: #fff, $color: #000, $border: solid 1px #e0e0e0, $border-radius: 4px) {\n    background-color: $background-color;\n    color: $color;\n    border: $border;\n    border-radius: $border-radius;\n}","// colors\n$url-color:#1C9AB4;\n$highlight-color:#e40927;\n$gray-bg-color:#bfbfbf;\n$info-bg-color:#a2d0ff58;\n$blue-icon-bg-color:#0000ff;\n$cds-primary:#0062fe;\n$cds-border-subtle:#e0e0e0;\n$header-grey:#f4f4f4;\n$light-grey: #e0e0e0;\n$text-grey: #525252;\n\n// fonts\n$header-font:30px;\n$roboto-font:Roboto,Arial,sans-serif;\n\n// spacing\n$spacers: 5%;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
